import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import { showModal } from "../statusModal/statusModal";

export const sendNotification = createAsyncThunk(
  "notifications/send",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("notification/send", payload);

      dispatch(
        showModal({ message: "تم ارسال الاشعار بنجاح", status: "success" })
      );

      return res.data;
    } catch (err) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء ارسال الاشعار", status: "error" })
      );
      return rejectWithValue(
        err.response?.data?.message || "Failed to send notification"
      );
    }
  }
);

const initialState = {
  sendStatus: "idle",
  error: null,
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendNotification.pending, (state) => {
        state.sendStatus = "loading";
        state.error = null;
      })
      .addCase(sendNotification.fulfilled, (state) => {
        state.sendStatus = "succeeded";
      })
      .addCase(sendNotification.rejected, (state, action) => {
        state.sendStatus = "failed";
        state.error = action.payload;
      });
  },
});

export default notificationSlice.reducer;
